module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-reset-password"
  }, [_c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    },
    on: {
      "reset": _vm.reload
    }
  }), (!_vm.isLoading) ? _c('div', {
    staticClass: "content"
  }, [_c('page-header', {
    attrs: {
      "title": _vm.title,
      "subTitle": _vm.subTitle,
      "error": _vm.formError
    }
  }), _c('form', {
    staticClass: "w-login-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitReset.apply(null, arguments)
      }
    }
  }, [(_vm.state === 'normal') ? _c('div', {
    staticClass: "password-form"
  }, [_c('div', {
    staticClass: "w-login-form__row w-login-form__row--email"
  }, [_c('password-input', {
    attrs: {
      "label": "New password",
      "autocomplete": "new-password",
      "required": "required"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _c('div', {
    staticClass: "w-login-form__row w-login-form__row--action"
  }, [_c('button', {
    staticClass: "w-button",
    class: {
      'w-button--gray': !_vm.canSubmit, 'w-button--blue': _vm.canSubmit
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.canSubmit
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Set new password")])])])]) : _vm._e(), (_vm.state === 'success') ? _c('div', {
    staticClass: "reset-success"
  }, [_c('ul', [(_vm.apps.projects) ? _c('li', [_c('a', {
    attrs: {
      "href": _vm.siteURL
    }
  }, [_vm._v("Continue to Teamwork")])]) : _vm._e(), (_vm.apps.desk) ? _c('li', [_c('a', {
    attrs: {
      "href": _vm.siteURL + 'desk/'
    }
  }, [_vm._v("Continue to Teamwork Desk")])]) : _vm._e(), (_vm.apps.chat) ? _c('li', [_c('a', {
    attrs: {
      "href": _vm.siteURL + 'chat/'
    }
  }, [_vm._v("Continue to Teamwork Chat")])]) : _vm._e(), (_vm.apps.spaces) ? _c('li', [_c('a', {
    attrs: {
      "href": _vm.siteURL + 'spaces/'
    }
  }, [_vm._v("Continue to Teamwork Spaces")])]) : _vm._e(), (_vm.apps.crm) ? _c('li', [_c('a', {
    attrs: {
      "href": _vm.siteURL + 'crm/'
    }
  }, [_vm._v("Continue to Teamwork CRM")])]) : _vm._e()])]) : _vm._e()])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f21a68b","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ResetPassword/ResetPassword.vue
// module id = 607
// module chunks = 1